<template>
  <div>
    <div style="height: calc(100vh - 50px)" class="overflow-y-auto hidescroll">
      <v-expansion-panels
        accordion
        v-model="expantionModel"
        flat
        multiple
        focusable
      >
        <v-expansion-panel>
          <v-expansion-panel-header
            style="height: 40px"
            color="rgb(238, 240, 248)"
            class="primary--text"
            ><span class="font-weight-bold">{{
              sections[0]
            }}</span></v-expansion-panel-header
          >
          <v-expansion-panel-content class="pt-2">
            <v-row class="mx-0 pa-0">
              <v-col cols="12" class="ma-0 px-0 py-2"
                ><v-autocomplete
                  v-model="doctor"
                  clearable
                  hide-details
                  dense
                  outlined
                  :items="$doctor.getLocalDocs()"
                  :filter="$util.doctorFilter"
                  label="By Doctor"
                  placeholder="Doctor"
                  return-object
                >
                  <template v-slot:selection="data">
                    {{ data.item.doctor_id.first_name }}
                    {{ data.item.doctor_id.last_name }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.doctor_id.first_name }}
                    {{ data.item.doctor_id.last_name }}
                  </template>
                </v-autocomplete></v-col
              >

              <v-col cols="12" class="ma-0 px-0 py-2">
                <v-autocomplete
                  v-model="department"
                  clearable
                  hide-details
                  dense
                  outlined
                  :items="departments"
                  :filter="$util.departmentFilter"
                  label="By Department"
                  placeholder="Department"
                  return-object
                >
                  <template v-slot:selection="data">
                    <v-avatar
                      style="
                        min-width: 18px !important;
                        min-height: 18px !important;
                      "
                      height="18px"
                      width="18px"
                      max-height="18px"
                      max-width="18px"
                      color="#d2e1f2"
                      left
                    >
                      <v-img
                        contain
                        height="10"
                        v-if="data.item.avatar"
                        :src="$root.asseturl + data.item.avatar.private_hash"
                      ></v-img>
                      <div
                        v-else
                        style="text-transform: uppercase; width: 100%"
                        class="primary--text font-size-h4"
                      >
                        {{ data.item.name.charAt(0) }}
                      </div>
                    </v-avatar>
                    {{ $util.getTranslation(data.item).name }}
                  </template>
                  <template v-slot:item="data">
                    <v-avatar
                      style="
                        min-width: 18px !important;
                        min-height: 18px !important;
                      "
                      class="pushx"
                      height="18px"
                      width="18px"
                      max-height="18px"
                      max-width="18px"
                      color="#d2e1f2"
                      left
                    >
                      <v-img
                        contain
                        height="10"
                        v-if="data.item.avatar"
                        :src="$root.asseturl + data.item.avatar.private_hash"
                      ></v-img>
                      <div
                        v-else
                        style="text-transform: uppercase; width: 100%"
                        class="primary--text"
                      >
                        {{ data.item.name.charAt(0) }}
                      </div>
                    </v-avatar>
                    {{ $util.getTranslation(data.item).name }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="ma-0 px-0 py-2" cols="12">
                <v-menu
                  v-model="created_on_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="created_on"
                      label="By booked on"
                      placeholder="Select date"
                      readonly
                      clearable
                      hide-details
                      dense
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="created_on"
                    @input="created_on_menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="ma-0 px-0 py-2" cols="12">
                <v-menu
                  v-model="date_time_menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date_time"
                      label="By Appointment Date"
                      placeholder="Select date"
                      readonly
                      clearable
                      hide-details
                      dense
                      outlined
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date_time"
                    @input="date_time_menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0">
                By Status
                <v-chip-group
                  column
                  active-class="primary--text"
                  v-model="status"
                >
                  <v-chip
                    v-for="item in statusOptions"
                    :key="item.id"
                    color="#d2e1f2"
                    small
                    class="primary--text"
                    active-class="white--text yellow darken-3"
                    filter
                  >
                    {{ item.title }}
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            style="height: 40px"
            color="rgb(238, 240, 248)"
            class="primary--text"
            ><span class="font-weight-bold">{{
              sections[1]
            }}</span></v-expansion-panel-header
          >
          <v-expansion-panel-content class="pt-2">
            <v-row class="mx-0 pa-0">
              <v-col cols="12" class="ma-0 pa-0">
                Sort by
                <v-chip-group
                  column
                  active-class="primary--text"
                  v-model="sort"
                >
                  <v-chip
                    v-for="item in sortOptions"
                    :key="item.id"
                    color="#d2e1f2"
                    small
                    class="primary--text"
                    active-class="white--text yellow darken-3"
                    filter
                  >
                    {{ item.title }}
                  </v-chip>
                </v-chip-group>
              </v-col>
              <v-col cols="12" class="ma-0 pa-0">
                Order
                <v-chip-group active-class="primary--text" v-model="order">
                  <v-chip
                    v-for="item in orderOptions"
                    :key="item.id"
                    color="#d2e1f2"
                    small
                    class="primary--text"
                    active-class="white--text yellow darken-3"
                    filter
                  >
                    {{ item.title }}
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <v-row style="height: 45px" class="px-3 ma-0 py-0">
      <v-col class="ma-0 py-0 px-1">
        <v-btn
          @click="reset()"
          block
          color="primary"
          rounded
          outlined
          elevation="0"
          >Reset</v-btn
        >
      </v-col>
      <v-col class="ma-0 py-0 px-1">
        <v-btn
          @click="apply()"
          block
          color="primary"
          rounded
          elevation="0"
          class="white--text"
          >Apply</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  components: {},
  name: "AppsFilter",
  data() {
    return {
      sections: ["Filters", "Sort"],
      statusOptions: [
        { id: 1, title: "Pending", value: "pending" },
        { id: 2, title: "In progress", value: "progress" },
        { id: 3, title: "Complete", value: "complete" },
        { id: 4, title: "Deleted", value: "deleted" }
      ],
      sortOptions: [
        { id: 1, title: "Booked On", value: "created_on" },
        { id: 2, title: "Appointment Date", value: "date_time" }
      ],
      orderOptions: [
        { id: 1, title: "Acending", value: "" },
        { id: 2, title: "Decending", value: "-" }
      ],
      expantionModel: [0, 1],

      created_on_menu: false,
      date_time_menu: false,

      //filters
      doctor: undefined,
      status: undefined,
      department: undefined,
      created_on: undefined,
      date_time: undefined,
      //sort
      order: undefined,
      sort: undefined
    };
  },

  created() {},
  watch: {},
  methods: {
    reset() {
      this.doctor = undefined;
      this.status = undefined;
      this.department = undefined;
      this.created_on = undefined;
      this.date_time = undefined;
      //sort
      this.order = undefined;
      this.sort = undefined;
      this.$emit("resetFilters", true);
    },
    apply() {
      let toreturn = { sort: undefined, filters: {} };
      if (this.sort !== undefined)
        toreturn.sort =
          this.order !== undefined
            ? this.orderOptions[this.order].value.concat(
                this.sortOptions[this.sort].value
              )
            : this.sortOptions[this.sort].value;
      if (this.status !== undefined)
        toreturn.filters.status = {
          operator: "eq",
          value: this.statusOptions[this.status].value
        };
      if (this.doctor !== undefined)
        toreturn.filters.doctor = { operator: "eq", value: this.doctor.id };
      if (this.department !== undefined)
        toreturn.filters["doctor.department"] = {
          operator: "eq",
          value: this.department.id
        };
      if (this.created_on !== undefined && this.created_on !== null)
        toreturn.filters.created_on = {
          operator: "contains",
          value: this.created_on
        };
      if (this.date_time !== undefined && this.date_time !== null) {
        toreturn.filters.date_time = {
          operator: "contains",
          value: this.date_time
        };
      }

      console.log(toreturn);
      this.$emit("updatefilters", toreturn);
    }
  },
  computed: {
    departments() {
      return this.$department.data.departments.data.filter(department => {
        return department.doctors.length > 0;
      });
    }
  },
  mounted() {}
};
</script>

<style></style>
